/* eslint-disable no-nested-ternary */

import React from 'react';
import { lowerCase } from 'lodash';
import { useParams } from 'react-router-dom';

import { Container, Navbar, NavbarBrand } from 'reactstrap';
import { PageTitle } from '@cordata/buffet';

import Identity from '~/assets/identity.svg';

import { ExtSwitch } from '~/components';

import { ExtProvider } from '~/utils';

const Ext = () => {
  const { type } = useParams();
  const title = type
    ? type.includes('register')
      ? 'Register to submit'
      : (`Submit ${lowerCase(type)}`)
    : '';

  return (
    <>
      <Navbar color="primary" dark expand="md" className="mb-3 sticky-top" style={{ height: '56px' }}>
        <NavbarBrand>
          <img src={Identity} width={130} alt="Navigator - Cordata" className="mr-2" />
        </NavbarBrand>
      </Navbar>

      <Container>
        <PageTitle>{title}</PageTitle>

        <ExtProvider>
          <ExtSwitch />
        </ExtProvider>

        <p className="pt-3 text-muted text-center"><small>Powered by <a href="https://www.cordatahealth.com/" target="_blank" rel="noopener noreferrer">Cordata</a></small></p>
      </Container>
    </>
  );
};

export default Ext;
